export default {
  methods: {
    mixCalcularFinanciamiento() {
      this.mixCalcularFinanciamientoImporteIndirectos();
      this.mixCalcularFinanciamientoImporteUtilidad();
      this.mixCalcularFinanciamientoImporteAdicionales();
      // this.mixCalcularFinanciamientoImporteCostoFinanciero();

      // Comprobar si es la estimacion finiquito
      // Si es estimacion finiquito entonces comprobar techa financiero
      if (this.estimacion.esEstimacionFiniquito) {
        this.mixFinanciamientoValidarTechoFinanciero();
      }
    },
    mixCalcularFinanciamientoImporteIndirectos() {
      const { importeCostoDirecto } = this.estimacion;
      const { porcentajeCostoIndirectos } = this.contrato;
      // porcentajeCostoIndirectos
      this.estimacion.importeCostoIndirectos = this.$numberRound(
        (importeCostoDirecto * (porcentajeCostoIndirectos / 100)),
      );
    },
    mixCalcularFinanciamientoImporteUtilidad() {
      const { porcentajeUtilidad } = this.contrato;
      this.estimacion.importeUtilidad = this.$numberRound(
        (this.mixImporteAntesUtilidad * (porcentajeUtilidad / 100)),
      );
    },
    mixCalcularFinanciamientoImporteAdicionales() {
      const { porcentajeCargosAdicionales } = this.contrato;
      this.estimacion.importeCargosAdicionales = this.$numberRound(
        (this.mixImporteAntesAdicionales * (porcentajeCargosAdicionales / 100)),
      );
    },
    mixCalcularFinanciamientoImporteCostoFinanciero() {
      const { porcentajeCostoFinanciero } = this.estimacion;
      this.estimacion.importeCostoFinanciero = this.$numberRound((
        this.mixImporteAntesCostoFinanciero * (porcentajeCostoFinanciero / 100)));
    },
    mixFinanciamientoValidarTechoFinanciero() {
      const { importeCostoIndirectos, importeUtilidad, importeCargosAdicionales } = this.contrato;
      // Resta para checar diferencia contra lo contratado
      const restaIndirectos = (importeCostoIndirectos - this.mixSumarImporteIndirectos);

      // Comprobar si hay diferencia
      if (restaIndirectos < 0 && restaIndirectos >= -0.10) {
        this.estimacion.importeCostoIndirectos += restaIndirectos;
      }

      // Resta para checar diferencia contra la utilidad contratada
      const restaUtilidad = (importeUtilidad - this.mixSumarImporteUtilidad);

      // Comprobar si la resta es menor
      if (restaUtilidad < 0 && restaUtilidad >= -0.10) {
        this.estimacion.importeUtilidad += restaUtilidad;
      }

      // Resta para checar la diferencia contra importe adicional contratado
      const restaAdicional = (importeCargosAdicionales - this.mixSumarImporteAdicionales);

      // Comprobar que la resta sea menor
      if (restaAdicional < 0 && restaAdicional >= -0.10) {
        this.estimacion.importeCargosAdicionales += restaAdicional;
      }
    },
  },
  computed: {
    mixImporteAntesUtilidad() {
      return this.$numberRound(
        (this.estimacion.importeCostoDirecto + this.estimacion.importeCostoIndirectos),
      );
    },
    mixImporteAntesAdicionales() {
      return this.$numberRound(
        (this.mixImporteAntesUtilidad + this.estimacion.importeUtilidad),
      );
    },
    mixImporteAntesCostoFinanciero() {
      return this.$numberRound(
        (this.mixImporteAntesAdicionales + this.estimacion.importeCargosAdicionales),
      );
    },
    mixSumarImporteIndirectos() {
      return (this.estimaciones
        .reduce((previo, { importeCostoIndirectos }) => previo + importeCostoIndirectos, 0)
        + this.estimacion.importeCostoIndirectos);
    },
    mixSumarImporteUtilidad() {
      return (this.estimaciones
        .reduce((previo, { importeUtilidad }) => previo + importeUtilidad, 0)
        + this.estimacion.importeUtilidad);
    },
    mixSumarImporteAdicionales() {
      return (this.estimaciones
        .reduce((previo, { importeCargosAdicionales }) => previo + importeCargosAdicionales, 0)
        + this.estimacion.importeCargosAdicionales);
    },
  },
};
